import { DateTime } from 'luxon';
export const zeroPad = (num, places) => String(num).padStart(places, '0');
export const countdownToDate = (date, now = new Date()) => {
    const nowTimestamp = Date.parse(now.toISOString());
    const dateTimestamp = Date.parse(date.toISOString());
    const t = dateTimestamp - nowTimestamp;
    const { days, hours, minutes, seconds, dayString, hourString, minuteString, secondString, isPast } = breakdownDuration(t);
    const timezone = DateTime.local().offsetNameShort;
    // This is a hack to get a fix live ASAP in the app because the real solve involves
    // native changes to the app to detect timezone on android
    const patchedZone = (timezone
        ? {
            'GMT-4': 'EDT',
            'GMT-5': 'CDT',
            'GMT-6': 'MDT',
            'GMT-7': 'PDT',
            'GMT-8': 'AKDT'
        }[timezone] || timezone
        : timezone) || undefined;
    const utcOffset = DateTime.local().offset / 60;
    const isInThePast24Hours = nowTimestamp < dateTimestamp + 1000 * 60 * 60 * 24;
    return {
        days,
        hours,
        minutes,
        seconds,
        dayString,
        hourString,
        minuteString,
        secondString,
        isPast,
        isInThePast24Hours,
        isVague: false,
        utcOffset,
        timezone: patchedZone,
        launchSeconds: 0
    };
};
export const breakdownDuration = (millis, allowNegative = false) => {
    const isPast = millis < 0;
    let days = Math.floor(Math.abs(millis / (1000 * 60 * 60 * 24)));
    let hours = Math.floor(Math.abs((millis / (1000 * 60 * 60)) % 24));
    let minutes = Math.floor(Math.abs((millis / 1000 / 60) % 60));
    let seconds = Math.floor(Math.abs((millis / 1000) % 60));
    if (isPast) {
        if (allowNegative) {
            if (days > 0) {
                days *= -1;
            }
            else if (hours > 0) {
                hours *= -1;
            }
            else if (minutes > 0) {
                minutes *= -1;
            }
            else if (seconds > 0) {
                seconds *= -1;
            }
        }
        else {
            days = 0;
            hours = 0;
            minutes = 0;
            seconds = 0;
        }
    }
    return {
        days,
        hours,
        minutes,
        seconds,
        dayString: zeroPad(days, 2),
        hourString: zeroPad(hours, 2),
        minuteString: zeroPad(minutes, 2),
        secondString: zeroPad(seconds, 2),
        isPast
    };
};
export const abbreviateDuration = (millis) => {
    if (millis === undefined) {
        return '?';
    }
    const { days, hours, minutes, seconds } = breakdownDuration(millis);
    const decimalDays = days + (hours + minutes / 60 + seconds / 3600) / 24;
    let decimalString = decimalDays === 0 ? '0' : decimalDays.toFixed(1);
    if (decimalDays === 0) {
        decimalString = '-';
    }
    else if (decimalDays < 0.1) {
        decimalString = '<.1';
    }
    decimalString = decimalString.replace('.0', '');
    return decimalString;
};
export const formatSimpleDate = (date) => {
    const components = (date || '').split('-');
    if (components && components.length < 3) {
        return '';
    }
    const month = parseInt(components[1], 10);
    const day = parseInt(components[2], 10);
    const year = parseInt(components[0], 10);
    const monthMap = {
        1: 'Jan',
        2: 'Feb',
        3: 'Mar',
        4: 'Apr',
        5: 'May',
        6: 'Jun',
        7: 'Jul',
        8: 'Aug',
        9: 'Sep',
        10: 'Oct',
        11: 'Nov',
        12: 'Dec'
    };
    const abbMonth = monthMap[month];
    return `${abbMonth} ${day}, ${year}`;
};
const getNumberSuffix = (num) => {
    const th = 'th';
    const rd = 'rd';
    const nd = 'nd';
    const st = 'st';
    if (num === 11 || num === 12 || num === 13)
        return th;
    let lastDigit = num.toString().slice(-1);
    switch (lastDigit) {
        case '1':
            return st;
        case '2':
            return nd;
        case '3':
            return rd;
        default:
            return th;
    }
};
export const relativeTimeDescription = (date) => {
    const now = DateTime.now();
    const timeDiff = date.diff(now, 'minutes').minutes;
    if (timeDiff < 0) {
        return `${Math.round(timeDiff * -1)} minutes ago`;
    }
    else if (timeDiff == 0) {
        return 'right now';
    }
    else if (timeDiff < 60) {
        return `in ${Math.round(timeDiff)} minute${timeDiff > 1 ? 's' : ''}`;
    }
    else if (timeDiff < 1440) {
        const hours = Math.round(timeDiff / 60);
        return `in ${hours} hour${hours > 1 ? 's' : ''}`;
    }
    else if (timeDiff < 10080) {
        const days = Math.round(timeDiff / 1440);
        return `in ${days} day${days > 1 ? 's' : ''}`;
    }
    else {
        return `On ${date.toFormat('LLLL d')}${getNumberSuffix(date.day)}`;
    }
};
export const relativeDayDescription = (date) => {
    if (date.hasSame(DateTime.local(), 'day')) {
        return 'today';
    }
    else if (date.hasSame(DateTime.local().plus({ days: 1 }), 'day')) {
        return 'tomorrow';
    }
    else if (date.hasSame(DateTime.local().minus({ days: 1 }), 'day')) {
        return 'yesterday';
    }
    else if (date.diff(DateTime.local(), 'day').days < 7) {
        return date.toFormat('cccc');
    }
    else {
        let formattedDate = date.toFormat('LLL dd');
        if (date.month === 9) {
            formattedDate = formattedDate.replace('Sep', 'Sept');
        }
        return formattedDate;
    }
};
//# sourceMappingURL=date.js.map